const shelfType = {
  "currentlyReading": {
    isShelf: true,
    text: "Currently Reading",
    className: "currently-reading"
  }, 
  "wantToRead": {
    isShelf: true,
    text: "Want To Read",
    className: "want-to-read",
  },
  "read": {
    isShelf: true,
    text: "Read",
    className: "read"
  },
  "none": {
    text: 'Add this book',
    alternativeText: 'Remove this book',
    className: 'none'
  }
}

export default shelfType


// WEBPACK FOOTER //
// ./src/enums/shelfType.js